module.exports = __webpack_public_path__ + "static/media/photo240.0df95372.jpg";